import { SITE_VIEW } from "./unit";

export const SITE_DETAILS_OPTION = {
  STATUS: "Status",
  ENERGYUSAGE: "Energy Usage",
  DEVICES: "Devices",
  HISTORY: "History",
  OPERATION: "Operation",
};

export const SITE_DETAILS_OPTIONS_TABS = [
  {
    value: SITE_DETAILS_OPTION.STATUS,
    label: SITE_DETAILS_OPTION.STATUS,
    accessKey: "status",
  },
  {
    value: SITE_DETAILS_OPTION.ENERGYUSAGE,
    label: SITE_DETAILS_OPTION.ENERGYUSAGE,
    accessKey: "energy_usage",
  },
  {
    value: SITE_DETAILS_OPTION.DEVICES,
    label: SITE_DETAILS_OPTION.DEVICES,
    accessKey: "status",
  },
  {
    value: SITE_DETAILS_OPTION.HISTORY,
    label: SITE_DETAILS_OPTION.HISTORY,
    accessKey: "history",
  },
  {
    value: SITE_DETAILS_OPTION.OPERATION,
    label: SITE_DETAILS_OPTION.OPERATION,
    accessKey: "operation",
  },
];

export const SITE_LIST_FITLERS = {
  organisation: "",
  group: "",
  state: "",
  dnsp: "",
  search: "",
  channel: "",
  installer: "",
  lifecycle: "",
  control_mode_status: "",
  regulatory_control: "",
  view: SITE_VIEW.LIST,
  paginationModel: {
    pageSize: 10,
    page: 0,
  },
  sortModel: [
    {
      field: "nmi",
      sort: "asc",
    },
  ],
};

// Order in which site device types are displayed. The first two are single
// objects (or null); the rest are lists. Each carries a human-readable title.
export const SITE_DEVICE_TYPES = [
  { key: "site_controller", label: "Site Controller", single: true },
  { key: "site_meter", label: "Site Meter", single: true },
  { key: "battery", label: "Battery" },
  { key: "hybrid_inverter", label: "Hybrid Inverter" },
  { key: "pv_inverter", label: "PV Inverter" },
  { key: "evcharger", label: "EV Charger" },
  { key: "hotwater", label: "Hot Water" },
  { key: "poolpump", label: "Pool Pump" },
  { key: "dred", label: "DRED" },
];

// Preferred column order and labels for known device fields. Fields not listed
// here are still shown, after these, with a humanised label.
export const SITE_DEVICE_FIELDS = {
  make: "Make",
  model: "Model",
  serial: "Serial",
  phase: "Phase",
  total_capacity: "Total Capacity",
  max_charge_power: "Max Charge Power",
  max_discharge_power: "Max Discharge Power",
  max_generation_power: "Max Generation Power",
  max_consumption_power: "Max Consumption Power",
  pv_curtail_capable: "PV Curtail Capable",
  platform: "Platform",
  created_at: "Created",
  id: "ID",
};

export const REGULATORY_CONTROL_OPTIONS = [
  { value: "dex", label: "deX" },
  { value: "none", label: "None" },
];
